module.exports = __webpack_public_path__ + "img/avatar-3.f7247f1c.jpg";